export default {
  wrapper: {
    position: 'relative',
    '& .Table': {
      '& td:first-child, th:first-child': {
        paddingLeft: 0,
      },
      '& td:last-child, th:last-child': {
        paddingRight: 0,
      },
    },
    '& .buttons': {
      display: 'flex',
      position: 'absolute',
      right: '25px',
      top: '30px',
      '& button + button': {
        marginLeft: '16px',
      },
    },
  },

  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0,
    background: ' hsla(0, 0%, 0%, 0.45)',
  },
}



// WEBPACK FOOTER //
// ./src/Components/CampaignQuote/styles.js